export function getDate(date) {
    let momentDate = moment(date);

    if (!date) {
        return '';
    }

    if (!momentDate.isValid()) {
        momentDate = moment();
    }

    return momentDate.format('YYYY-MM-DD');
}

export function getTime(date) {
    let momentDate = moment(date);

    if (!momentDate.isValid() || !date) {
        return '';
    }

    if (!momentDate.isValid()) {
        momentDate = moment();
    }

    return momentDate.format('HH:mm:ss');
}
